import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ImgToolbarEditing from './imgtoolbarediting';

export default class ImgToolbar extends Plugin {
  static get requires() {
    return [ImgToolbarEditing];
  }

  static get pluginName() {
    return 'ImgToolbar';
  }
}